import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { SsoConnectionForManipulationDto } from '../types';
import { SsoConnectionKeys } from './ssoConnection.keys';

export const createSsoConnection = async (
  ssoConnectionForCreationDto: SsoConnectionForManipulationDto,
) => {
  await clients.admin.post(`/ssointegrations`, ssoConnectionForCreationDto);
};

export function useCreateSsoConnection(
  orgId: string,
  options?: UseMutationOptions<void, AxiosError, SsoConnectionForManipulationDto>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    (ssoConnectionForCreationDto: SsoConnectionForManipulationDto) =>
      createSsoConnection(ssoConnectionForCreationDto),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(SsoConnectionKeys.detail(orgId));
      },
      ...options,
    },
  );
}
